<template>
    <b-modal id="AdvertiseModal" hide-footer hide-header ref="advertiseModal">
        <div class="advertise-modal-wrapper">
            <div class="advertise-modal-image-bloc">
                <img src="@/assets/img/triplea/home/advertise-modal-image.png"/>
            </div>
            <div class="advertise-modal-content-bloc">
                <div class="advertise-modal-content-title-row">
                    <h3>Anuncie seu imóvel</h3>
                    <button class="modal-close-button" @click="closeModal">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.22259 4.22208C4.65216 3.79251 5.34865 3.79251 5.77822 4.22208L12.0004 10.4443L18.2226 4.22208C18.6522 3.79251 19.3486 3.79251 19.7782 4.22208C20.2078 4.65166 20.2078 5.34814 19.7782 5.77772L13.556 11.9999L19.7782 18.2221C20.2078 18.6517 20.2078 19.3482 19.7782 19.7777C19.3487 20.2073 18.6522 20.2073 18.2226 19.7777L12.0004 13.5555L5.77821 19.7777C5.34863 20.2073 4.65215 20.2073 4.22257 19.7777C3.793 19.3482 3.793 18.6517 4.22257 18.2221L10.4448 11.9999L4.22259 5.77772C3.79301 5.34814 3.79301 4.65166 4.22259 4.22208Z" fill="#333333"/>
                        </svg>
                    </button>
                </div>
                <div class="advertise-modal-content-resume-row">
                    <p>
                        Simples e prático, após preencher os seus dados abaixo uma equipe especializada entrará em contato.
                    </p>
                </div>
                <div class="advertise-modal-content-form-row">
                    <form>
                        <div class="advertise-modal-line">
                            <label class="advertise-modal-line-label">Esse imóvel esta para:</label>
                            <div class="advertise-modal-button-wrapper" data-toggle="buttons">
                                <label
                                    :class="{ active: selectedValue === 'vender' }"
                                    @click="selectValue('vender')"
                                >
                                    Vender
                                </label>
                                <label
                                    :class="{ active: selectedValue === 'alugar' }"
                                    @click="selectValue('alugar')"
                                >
                                    Alugar
                                </label>
                            </div>
                        </div>
                        <div class="advertise-modal-form-line-properties-type">
                            <label>Qual o tipo desse imóvel?</label>
                            <div class="advertise-modal-form-properties-type-box">
                                <div class="advertise-modal-form-properties-type-item active">
                                    <img src="@/assets/img/triplea/home/filter-icons/modal/apartamento.svg"/>
                                    <p>Apartamento</p>
                                </div>
                                <div class="advertise-modal-form-properties-type-item">
                                    <img src="@/assets/img/triplea/home/filter-icons/modal/casa-e-sobrado.svg"/>
                                    <p>Casa e sobrado</p>
                                </div>
                                <div class="advertise-modal-form-properties-type-item">
                                    <img src="@/assets/img/triplea/home/filter-icons/modal/comercial.svg"/>
                                    <p>Comercial</p>
                                </div>
                                <div class="advertise-modal-form-properties-type-item">
                                    <img src="@/assets/img/triplea/home/filter-icons/modal/terreno.svg"/>
                                    <p>Terreno</p>
                                </div>
                            </div>
                        </div>
                        <div class="advertise-modal-form-line">
                            <label class="advertise-modal-form-label">
                                <span>Qual a localização?</span>
                                <input class="advertise-modal-form-input" placeholder="Digite aqui">
                            </label>
                            <label class="advertise-modal-form-label">
                                <span>Telefone</span>
                                <input class="advertise-modal-form-input" placeholder="(41) 99999.9393">
                            </label>
                        </div>
                        <div class="advertise-modal-form-line">
                            <label class="advertise-modal-form-label">
                                <span>E-mail</span>
                                <input class="advertise-modal-form-input" placeholder="Apolino@apolar.com.br">
                            </label>
                        </div>
                        <div class="advertise-modal-form-button-line">
                            <button class="advertise-modal-form-button">Enviar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
  import "@/assets/scss/custom/triplea/components/_home_advertise_modal.scss"
  export default {
    data() {
        return {
        selectedValue: 'vender',
        };
    },
    methods: {
        selectValue(value) {
            this.selectedValue = value;
        },
        closeModal() {
            this.$refs.advertiseModal.hide();
        },
    } 
  }
</script>
